import { useEffect, useState } from "react";

import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

import { readVoltRoles, voltAreas } from "../navigation/voltAreas";

export type WorkshopAccess = "loading" | "granted" | "denied";

/** Same rule as the menu: Werkstatt access from the session token; the API checks again. */
export const useWorkshopAccess = (): WorkshopAccess => {
  const [access, setAccess] = useState<WorkshopAccess>("loading");
  useEffect(() => {
    // INITIAL_SESSION fires right after subscribing.
    const { data } = getSupabaseClient().auth.onAuthStateChange(
      (_event, session) => {
        const areas = voltAreas(readVoltRoles(session?.access_token));
        setAccess(areas.werkstatt.length > 0 ? "granted" : "denied");
      },
    );
    return () => data.subscription.unsubscribe();
  }, []);
  return access;
};
